import { AbstractCryptoConfig } from '../base';
import { AccountSignatureConfigDumpArgs, AccountSignatureConfigLoadArgs } from './args';
import { Ed25519DS } from '../../base/ds/ec';
import { AbstractAccountKeyring } from '../../keyring/account_base';
import { concatByteArray } from '../../utility';
import { CryptoUpgrade } from '../feature';
import { MLDSA87DS } from '../../base/ds/ml';

/**
 * Account signature: detached Ed25519 and MLDSA87
 */
export class AccountSignatureConfigV2 extends AbstractCryptoConfig<
  AccountSignatureConfigLoadArgs,
  AccountSignatureConfigDumpArgs
> {
  constructor(cu: CryptoUpgrade) {
    super(2, cu);
  }

  public async load(args: AccountSignatureConfigLoadArgs): Promise<Uint8Array> {
    await MLDSA87DS.verify(
      args.cipher.slice(this.version.byteLength + 64),
      args.peer_kr.get_public_key(AbstractAccountKeyring.MLDSA87),
      args.plain
    );
    await Ed25519DS.verify(
      args.cipher.slice(this.version.byteLength, this.version.byteLength + 64),
      args.peer_kr.get_public_key(AbstractAccountKeyring.ED25519),
      args.plain
    );
    return args.plain;
  }

  public async dump(args: AccountSignatureConfigDumpArgs): Promise<Uint8Array> {
    const mldsa87_sk = args.self_kr.get_secret_key(AbstractAccountKeyring.MLDSA87);
    const ml_s = await MLDSA87DS.sign(args.plain, mldsa87_sk);
    const ec_s = await Ed25519DS.sign(
      args.plain,
      concatByteArray(
        args.self_kr.get_secret_key(AbstractAccountKeyring.ED25519),
        args.self_kr.get_public_key(AbstractAccountKeyring.ED25519)
      )
    );
    return concatByteArray(this.version, ec_s, ml_s);
  }
}
